import React from 'react';
import { Button, Typography, makeStyles, Box } from '@material-ui/core';
import _get from 'lodash/get';
import _classNames from 'classnames';
import Badge from 'components/Badge';
import useSiteCopySelector from '../useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  container: {
    alignItems: 'center',
    borderRadius: '10px !important',
    background: `${theme.palette.text.white} !important`,
    '& p': {
      margin: 0,
    },
    '& section': {
      padding: 0,
    },
  },
  header: {
    marginTop: 5,
    '& img': {
      scale: '1.4',
      marginBottom: 3,
      paddingRight: 2,
      paddingLeft: 6,
    },
  },
  headerBackground: {
    position: 'absolute',
    width: '100%',
    height: 93,
    borderBottomLeftRadius: 30,
    background: props =>
      `linear-gradient(to right, ${props.cardColor} 80%, ${theme.palette.text.white} 140%)`,
  },
  title: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '1.5',
    maxHeight: 'calc(1.5em * 2)',
    marginTop: 4,
    padding: '0 10px',
  },
  body: {
    width: '100%',
    padding: '8px !important',
    zIndex: 1,
  },
  imageContainer: {
    marginTop: 4,
  },
  image: {
    width: 154,
  },
  playIcon: {
    position: 'absolute',
  },
  actionButton: {
    margin: 'auto 0 24px !important',
  },
  progress: {
    width: '100%',
    zIndex: 1,
  },
  headerRight: {
    gap: 5,
  },
}));

const AudioOnlySeries = ({
  classes,
  time,
  cardColor,
  actionButtonLabel,
  backgroundImage,
  resourceItemPageSiteCopy,
  title,
  siteCopy,
  isCompleted,
  onNavigate,
}) => {
  const styles = useStyles({ cardColor });
  const [learningLabSiteCopy] = useSiteCopySelector(['learning-lab']);
  const badgeLabel = isCompleted
    ? _get(siteCopy, 'pageCopy.completedCTA')
    : _get(learningLabSiteCopy, 'pageCopy.newLabel');

  return (
    <Box
      onClick={onNavigate}
      className={_classNames(classes.card, styles.container)}
    >
      <Box className={styles.headerBackground} />
      <Box className={_classNames(classes.progress, styles.progress)} />
      <Box className={_classNames(classes.plainCardBody, styles.body)}>
        <Box
          className={styles.header}
          display="flex"
          justifyContent="space-between"
        >
          <Badge customClasses={classes} removeMargin type="audioSeries" />
          <Box
            className={_classNames(
              classes.plainCardRightContainer,
              styles.headerRight,
            )}
          >
            {time && (
              <p>{`${time}${_get(
                resourceItemPageSiteCopy,
                'pageCopy.durationLabelShortSymbol',
              )}`}</p>
            )}
            <p className={classes.completedBadge}>{badgeLabel}</p>
          </Box>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          className={styles.imageContainer}
        >
          <img src={backgroundImage} alt="Series" className={styles.image} />
        </Box>
        <Typography
          className={_classNames(classes.plainCardTitle, styles.title)}
          variant="h5"
          color="textPrimary"
        >
          {title}
        </Typography>
        <Button
          className={_classNames(classes.plainCardButton, styles.actionButton)}
          variant="contained"
          color="primary"
          aria-label={`${title} ${actionButtonLabel}`}
        >
          {actionButtonLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default AudioOnlySeries;
